import { ReactComponent as SlashForwardSvg } from '@sketch/icons/slash.forward.regular-20'
import styled from 'styled-components'

export const BreadcrumbDivider = styled(SlashForwardSvg)`
  width: 20px;
  height: 20px;
  flex: none;
  color: ${({ theme }) => theme.colors.foreground.secondary.D};
`
